import { render, staticRenderFns } from "./ValuePropositionView.vue?vue&type=template&id=3b1fd392&scoped=true"
import script from "../js/ValueProposition/index.js?vue&type=script&lang=js&external"
export * from "../js/ValueProposition/index.js?vue&type=script&lang=js&external"
import style0 from "./ValuePropositionView.vue?vue&type=style&index=0&id=3b1fd392&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1fd392",
  null
  
)

export default component.exports